import AssignmentField from './AssignmentField';
import GoalField from './GoalField';
import KpiIdField from './KpiIdField';
import Participants from './Participants';
import PeriodField from './PeriodField';
import TeamAssignmentField from './TeamAssignmentField';
import TypeField from './TypeField';

export const getKpisCustomFields = (props) => {
    switch (props.field.id) {
        case 'participants':
            return <Participants key={props.field.id} {...props} />;
        case 'kpiId':
            return <KpiIdField key={props.field.id} {...props} />;
        case 'assignment':
            return <AssignmentField key={props.field.id} {...props} />;
        case 'type':
            return <TypeField key={props.field.id} {...props} />;
        case 'teamAssignment':
            return <TeamAssignmentField key={props.field.id} {...props} />;
        case 'periodGroup':
            return <PeriodField key={props.field.id} {...props} />;
        case 'goalFieldGroup':
        default:
            return <GoalField key={props.field.id} {...props} />;
    }
};
